import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import { Button, Progress, Collapse, Modal, ModalBody, ModalFooter, Tooltip, Badge} from 'reactstrap';
import Select from 'react-select';
import {PickupStatus} from './PickupStatus';
import {BpTspSolver} from '../../assets/libs/BpTspSolver';
import {toastr} from 'react-redux-toastr';
import {apiPost} from '../../utils/request';
import SortableMap from './SortableMap';
import { mustBeArray } from '../../utils/lib';
import AddNotes from '../Notes/AddNotes';
import {push} from "../../utils/navigation";
import {BASE_URL} from "../../constants";
import {getIsCollectionRun, getRunFlag} from "../../utils/collectionTypes";
import {loadDriverRuns, loadRun, loadRuns} from "../../actions/runActions";
import store from '../../store';

const editableView = (pickup, onItemChange, onRemoveItem, pickupStatusList, handleStatusChange, enableEditing, isCollectionRun) => {
  return (<div style={{marginLeft: 'auto', display: "flex", alignItems: "center", justifyContent: "flex-start", flexWrap: "wrap"}} className="run-edit">
    <div style={{marginBottom: "10px", marginTop: "10px", display: 'flex'}}  className="run-edit-actions align-items-center">
      {pickup.pickupStatusCode !== 'COM' && <React.Fragment>      
        <span>&nbsp;Urgent&nbsp;</span>      
        <label className="switch switch-3d switch-danger" style={{marginBottom: 0}}>
          <input type="checkbox"
                  className="switch-input"
                  checked={pickup.isUrgentJob}
                  onChange={() => {                  
                    // this is a hack, as client requests is fucked                  
                    if(pickup.isUrgentJob === true) {
                      window.open(`${BASE_URL}/client-requests`, '_blank');  
                    }
                    else {
                      const urlFragment = isCollectionRun ? 'request-urgent-collection' : 'request-oil-delivery';
                      window.open(`${BASE_URL}/${urlFragment}/${pickup.locationID}`, '_blank');
                    }
                  }}
          />
          <span className="switch-label" />
          <span className="switch-handle" />
        </label>
      </React.Fragment> }
      <Button style={{marginLeft: '10px', marginRight: "10px"}} color="danger" onClick={() => onRemoveItem(pickup)}><i className="fa fa-times" /></Button>
    </div>
    {
      enableEditing && 
      <span style={{
        width: '180px'
      }}
      className="run-edit-status"
      >
          <Select
            name="pickupStatus"
            value={pickup.pickupStatusCode}
            multi={false}
            simpleValue={true}
            clearable={false}
            options={pickupStatusList}
            onChange={(e) => handleStatusChange(pickup, e)}
          />
      </span>
    }
    
    </div>);
};

const PickupItem = ({value, colour, icon, pickup, onItemChange, onRemoveItem, pickupStatusList, 
  handleStatusChange, toggleNotesModal, projectedFields, handleDeleteNote, viewCompletedRun, enableEditing, isCollectionRun}) => {
  let editable = !pickup.isBase;
  return (
    <div
      className={`list-group-item list-group-item-${colour}`}
      style={{display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap"}}
    >
      <div style={{flex: "1 1 50%"}}>
        <div>
            {value}&nbsp;{icon && (icon !== "fa fa-square-o") &&<i className={icon}/> }
          {pickup && pickup.confirmationResponse && 
          <React.Fragment>
            <Tooltip target="ConfirmedResponseIcon">Response Confirmed</Tooltip>
            <span style={{marginLeft: '10px'}} id="ConfirmedResponseIcon"><i className="fa fa-comment" /></span>
          </React.Fragment>
          }
        </div>
    {
      pickup && !pickup.isTinLocation &&
      <React.Fragment>
        <div>Max Capacity: {projectedFields && projectedFields.capacityLitres}L</div>
        <div>Projected: {projectedFields && projectedFields.percentageOfCapacity}%</div>
        <div>Projected +7 days: {projectedFields && projectedFields.percentageOfCapacityPlus7}%</div>
      </React.Fragment>
    }
    {
      (!pickup || (!pickup.pickupNote && !pickup.cancelReason)) && !viewCompletedRun &&
      <Button className="ghost-button text-primary hand" 
        onClick={e => toggleNotesModal({e,type:  "pickupNote"})}>
          <i className="fa fa-plus" />&nbsp;New Note
      </Button>
    }
    {
      pickup && pickup.pickupNote  && !viewCompletedRun &&
      <div>
        <b>Notes:</b> {pickup.pickupNote} &nbsp;
        <div style={{marginBottom: "10px"}}>
          <Button className="ghost-button text-primary hand" style={{marginRight: "16px"}} 
            onClick={e => toggleNotesModal({e,type:  "pickupNote"})}>
              <i className="fa fa-pencil" />&nbsp;Edit Note
          </Button>
          <Button className="ghost-button text-danger hand" 
            onClick={e => handleDeleteNote({e,type:  "pickupNote"})}>
              <i className="fa fa-times" />&nbsp;Delete Note
          </Button>
        </div>
      </div>
    }
    {
      pickup && pickup.cancelReason  && !viewCompletedRun &&
      <div>
        <b>Notes:</b> {pickup.cancelReason} &nbsp;
        <Button className="ghost-button text-primary hand" 
        onClick={e => toggleNotesModal({e,type:  "cancelReason"})}>
          <i className="fa fa-pencil" />
      </Button>
      </div>
    }
    </div>
    {
     editable &&
    <div style={{flex: "1 1 50%"}}>
       {editableView(pickup, onItemChange, onRemoveItem, pickupStatusList, handleStatusChange, enableEditing, isCollectionRun) }
      </div>
    }
    </div>);
};

const SortablePickupItem = SortableElement(({value, colour, icon, pickup, onItemChange, onRemoveItem, pickupStatusList, 
  handleStatusChange, toggleNotesModal, projectedFields, handleDeleteNote, viewCompletedRun, enableEditing, isCollectionRun}) => {
  let editable = !pickup.isBase;
  return (
    <div
      className={`list-group-item list-group-item-${colour}`}
      style={{display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap"}}
    >
      <div style={{flex: "1 1 50%"}}>
        <div>
            {value}&nbsp;{icon && (icon !== "fa fa-square-o") &&<i className={icon}/> }
          {pickup && pickup.confirmationResponse && 
          <React.Fragment>
            <Tooltip target="ConfirmedResponseIcon">Response Confirmed</Tooltip>
            <span style={{marginLeft: '10px'}} id="ConfirmedResponseIcon"><i className="fa fa-comment" /></span>
          </React.Fragment>
          }
        </div>
    {
      pickup && !pickup.isTinLocation && !pickup.isBase &&
      <React.Fragment>
        <div>Max Capacity: {projectedFields && projectedFields.capacityLitres}L</div>
        <div>Projected: {projectedFields && projectedFields.percentageOfCapacity}%</div>
        <div>Projected +7 days: {projectedFields && projectedFields.percentageOfCapacityPlus7}%</div>
      </React.Fragment>
    }
    {
      (!pickup || (!pickup.pickupNote && !pickup.cancelReason)) && !viewCompletedRun && !pickup.isBase &&
      <Button className="ghost-button text-primary hand" 
        onClick={e => toggleNotesModal({e,type:  "pickupNote"})}>
          <i className="fa fa-plus" />&nbsp;New Note
      </Button>
    }
    {
      pickup && pickup.pickupNote  && !viewCompletedRun &&
      <div>
        <b>Notes:</b> {pickup.pickupNote} &nbsp;
        <div style={{marginBottom: "10px"}}>
          <Button className="ghost-button text-primary hand" style={{marginRight: "16px"}} 
            onClick={e => toggleNotesModal({e,type:  "pickupNote"})}>
              <i className="fa fa-pencil" />&nbsp;Edit Note
          </Button>
          <Button className="ghost-button text-danger hand" 
            onClick={e => handleDeleteNote({e,type:  "pickupNote"})}>
              <i className="fa fa-times" />&nbsp;Delete Note
          </Button>
        </div>
      </div>
    }
    {
      pickup && pickup.cancelReason  && !viewCompletedRun &&
      <div>
        <b>Notes:</b> {pickup.cancelReason} &nbsp;
        <Button className="ghost-button text-primary hand" 
        onClick={e => toggleNotesModal({e,type:  "cancelReason"})}>
          <i className="fa fa-pencil" />
      </Button>
      </div>
    }
    </div>
    {
     editable &&
    <div style={{flex: "1 1 50%"}}>
       {editableView(pickup, onItemChange, onRemoveItem, pickupStatusList, handleStatusChange, enableEditing, isCollectionRun) }
      </div>
    }
    </div>);
});

const SortablePickups = SortableContainer(({items, onItemChange, onRemoveItem, pickupStatusList, handleStatusChange, handleDeleteNote, 
  toggleNotesModal, projectedValuesList, viewCompletedRun, enableEditing, isCollectionRun}) => {
  return (
    <div style={{overflow:'auto', paddingRight: '50px'}}>
      {items.map((p, index) =>
        {
          let status = PickupStatus({pickupStatusCode: p.pickupStatusCode, isUrgentJob: p.isUrgentJob, isUrgentDelivery: p.isUrgentDelivery, isUrgentCollection: p.isUrgentCollection}, isCollectionRun ? 'B' : 'BD');
          let defaultStatus = PickupStatus(p, isCollectionRun ? 'B' : 'BD');
          const projectedFields = projectedValuesList.find(o => o.id === p.locationID);
        return (<SortablePickupItem
          key={`pickup-${index}`}
          index={index}
          value={`#${p.pickupOrder+1} - ${p.clientCompanyName} - ${p.locationFullAddress}`}
          colour={status.colour || (defaultStatus && defaultStatus.colour)}
          icon={status.icon}
          disabled={p.isBase}
          pickup={p}
          onItemChange={(evnt) => onItemChange(p, evnt.target.checked)}
          onRemoveItem={onRemoveItem}
          pickupStatusList = {pickupStatusList} 
          handleStatusChange={handleStatusChange}
          toggleNotesModal={({type, e}) => toggleNotesModal({activeRecord: p, e,type})}
          handleDeleteNote={({type, e}) => handleDeleteNote({activeRecord: p, e,type})}
          projectedFields={projectedFields}
          viewCompletedRun={viewCompletedRun}
          enableEditing={enableEditing}
          isCollectionRun={isCollectionRun}
        />);}
      )}
    </div>
  );
});

const UnSortablePickups = ({items, onItemChange, onRemoveItem, pickupStatusList, handleStatusChange, handleDeleteNote, 
  toggleNotesModal, projectedValuesList, viewCompletedRun, enableEditing, isCollectionRun}) => {
  return (
    <div style={{overflow:'auto', paddingRight: '50px'}}>
      {items.map((p, index) =>
        {
          let status = PickupStatus({pickupStatusCode: p.pickupStatusCode, isUrgentJob: p.isUrgentJob, isUrgentDelivery: p.isUrgentDelivery, isUrgentCollection: p.isUrgentCollection}, isCollectionRun ? 'B' : 'BD');
          let defaultStatus = PickupStatus(p, isCollectionRun ? 'B' : 'BD');
          const projectedFields = projectedValuesList.find(o => o.id === p.id);
        return (
        enableEditing ?
        <PickupItem
          key={`pickup-${index}`}
          index={index}
          value={`#${p.pickupOrder+1} - ${p.clientCompanyName} - ${p.locationFullAddress}`}
          colour={status.colour || (defaultStatus && defaultStatus.colour)}
          icon={status.icon}
          disabled={p.isBase}
          pickup={p}
          onItemChange={(evnt) => onItemChange(p, evnt.target.checked)}
          onRemoveItem={onRemoveItem}
          pickupStatusList = {pickupStatusList} 
          handleStatusChange={handleStatusChange}
          toggleNotesModal={({type, e}) => toggleNotesModal({activeRecord: p, e,type})}
          handleDeleteNote={({type, e}) => handleDeleteNote({activeRecord: p, e,type})}
          projectedFields={projectedFields}
          viewCompletedRun={viewCompletedRun}
          enableEditing={enableEditing}
          isCollectionRun={isCollectionRun}
        />
        :
        <SortablePickupItem
          key={`pickup-${index}`}
          index={index}
          value={`#${p.pickupOrder+1} - ${p.clientCompanyName} - ${p.locationFullAddress}`}
          colour={status.colour || (defaultStatus && defaultStatus.colour)}
          icon={status.icon}
          disabled={p.isBase}
          pickup={p}
          onItemChange={(evnt) => onItemChange(p, evnt.target.checked)}
          onRemoveItem={onRemoveItem}
          pickupStatusList = {pickupStatusList} 
          handleStatusChange={handleStatusChange}
          toggleNotesModal={({type, e}) => toggleNotesModal({activeRecord: p, e,type})}
          handleDeleteNote={({type, e}) => handleDeleteNote({activeRecord: p, e,type})}
          projectedFields={projectedFields}
          viewCompletedRun={viewCompletedRun}
          enableEditing={enableEditing}
          isCollectionRun={isCollectionRun}
        />
        );}
      )}
    </div>
  );
};

class OrderPickups extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      run: {...props.run},
      original: {...props.run},
      projectedValuesList: [],
      isOrdering: false,
      googleOrderProgressPercent: 0,
      orderMode: 'list',
      viewModal: false,
      selectedItem: {},
      pickupStatusList: [{value:'PEN', label:'Pending'},
                    {value:'COM', label:'Completed'},
                    {value:'CREQ', label:'Confirmation Requested'},
                    {value:'CAN', label:'Cancelled'}], 
      viewNotesModal: false,
      activeRecord: {},
      noteType: "pickupNote",
      enableEditing: false,
    };
    this.onSortEnd = this.onSortEnd.bind(this);
    this.resetRun = this.resetRun.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saveRun = this.saveRun.bind(this);
    this.enterReOrder = this.enterReOrder.bind(this);
    this.reOrderWithGoogle = this.reOrderWithGoogle.bind(this);
    this.reOrderTakeTwo = this.reOrderTakeTwo.bind(this);
    this.reOrderTakeThree = this.reOrderTakeThree.bind(this);
    this.onItemChange = this.onItemChange.bind(this);
    this.onRemoveItem = this.onRemoveItem.bind(this);
    this.handleMapOrderFinished = this.handleMapOrderFinished.bind(this);
    this.orderWithMap = this.orderWithMap.bind(this);
    this.toggle = this.toggle.bind(this);
    this.saveNotes= this.saveNotes.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  handleStatusChange = (pickup, input) => {
    this.setState(prevState => {
      let pickupList = mustBeArray(prevState.run && prevState.run.pickups);
      pickupList = pickupList.map(item => {
        return(pickup.id === item.id ? {...item, pickupStatusCode: input} : item);
      });
      prevState.run.pickups = [...pickupList];
      return prevState;
    });
  }

  onSortEnd = ({oldIndex, newIndex}) => {
    let run = {...this.state.run};
    let pickups = arrayMove([...run.pickups], oldIndex, newIndex);

    //Set the pickup order
    for(let i = 0; i < pickups.length; i++){
      pickups[i] = {...pickups[i], pickupOrder: i};
    }
    run.pickups = pickups;
    if(this.refs.sortMap){
      this.refs.sortMap.moveIndex(oldIndex, newIndex);
    }
    this.setState({ run });
  };

  handleMapOrderFinished(run, withChanges){
    this.setState({ run: {...run, allowAutoReorder: (withChanges ? false : this.state.allowAutoReorder)}, orderMode: 'list' });
  }

  resetRun(){
    this.setState({run: {...this.state.original}});
  }

  cancel(){
    this.resetRun();
    this.setState({isOrdering: false});
    if(this.props.onLeaveReOrderRun){
      this.props.onLeaveReOrderRun();
    }
    if(this.props.viewCompletedRun && this.props.handleViewCompletedRun){
      this.props.handleViewCompletedRun();
    }
  }

  saveRun(){
    this.setState({isOrdering: false});
    this.props.onFinishOrderRun(this.state.run);
  }

  refresh(){
    // TODO: This does not refresh
    store.dispatch(loadDriverRuns());    
  }

  enterReOrder(){
    if(this.props.isEditView){
      this.props.loadProjectedRunFields({runId: this.state.run && this.state.run.id}).then(resp => {
        this.setState({ projectedValuesList: mustBeArray(resp && resp.data)});
      });
    }
    this.setState({isOrdering: this.props.isEditView ? true : false});
    if(this.props.onEnterReOrderRun){
      this.props.onEnterReOrderRun();
    }
  }

  reOrderTakeThree(){
    this.setState({googleOrderProgressPercent: 50, run: {...this.state.run, allowAutoReorder: true}});
    let request = { pickups: this.state.run.pickups.map(p => {
      return {
        id: p.id,
        pickupOrder: p.pickupOrder,
        locationId: p.locationID,
        latitude: p.locationLatitude,
        longitude: p.locationLongitude,
        pickupStatusCode: p.pickupStatusCode,
        isCheckIn: p.isCheckIn,
        isCheckOut: p.isCheckOut,
      };
    })};

    apiPost('/api/locations/route', request)
      .then((x) =>{
        this.setState({googleOrderProgressPercent: 0});
        let result = x.data.pickups;

        let run = {...this.state.run};
        run.pickups = [...run.pickups.map(p => {
          let returnVal = {...p};
          let found = result.find(a => a.id == returnVal.id);
          if(found){
            console.log(`Updating order ${found.pickupOrder} to ${found.updatedPickupOrder}`);
            returnVal.pickupOrder = found.updatedPickupOrder;
          }
          return returnVal;
        })];
        run.pickups = run.pickups.sort((a, b) => {
          if (a.pickupOrder < b.pickupOrder) {
            return -1;
          }
          if (a.pickupOrder > b.pickupOrder) {
            return 1;
          }
          return 0;
        });
        this.setState({run});
        if(this.refs.sortMap) {
          this.refs.sortMap.resetSelected();
        }
      });
  }

  reOrderTakeTwo(){
    this.setState({googleOrderProgressPercent: 50});
    let points = this.state.run.pickups.map(x => {
      return {location: {
        lat: x.locationLatitude,
        lng: x.locationLongitude
      }};
    });
    points = points.slice(0,25);
    let waypoints = points.slice(1,Math.min(24, points.length-1));

    const DirectionsService = new google.maps.DirectionsService();
    DirectionsService.route({
      origin: points[0],
      destination: points[points.length-1],
      waypoints: waypoints,
      optimizeWaypoints: true,
      travelMode: google.maps.TravelMode.DRIVING,
    }, (result, status) => {
      this.setState({googleOrderProgressPercent: 75});
      if (status === google.maps.DirectionsStatus.OK) {
        if(result.routes && result.routes.length > 0){
          let route = result.routes[0];
          let order = route.waypoint_order;

          let run = {...this.state.run};
          let pickups = [...run.pickups];

          for(let i = 0; i < order.length; i++){
            pickups[order[i]+1] = {...pickups[order[i]+1], pickupOrder: i+1};
          }
          run.pickups = pickups.sort((a, b) => {
            if (a.pickupOrder < b.pickupOrder) {
              return -1;
            }
            if (a.pickupOrder > b.pickupOrder) {
              return 1;
            }
            return 0;
          });

          this.setState({
            run,
            googleOrderProgressPercent: 0
          });
        }
        this.setState({googleOrderProgressPercent: 0});
      } else {
        this.setState({googleOrderProgressPercent: 0});
        toastr.error(`Error fetching directions ${result}`);
      }
    });
  }

  reOrderWithGoogle() {
    let waypoints = this.state.run.pickups.map(x => {
      return {location: {
        lat: x.locationLatitude,
        lng: x.locationLongitude
      }};
    });

    console.log(waypoints);

    let mapOptions = {
      zoom: 20,
      center: waypoints[0].location,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    let showError = (err) => {
      console.log('Error', err);
      toastr.error(`Error while re-ordering: ${err}`);
      this.setState({googleOrderProgressPercent: 0});
    };

    let map = new google.maps.Map(this.refs.map, mapOptions);
    let tsp = new BpTspSolver(map, this.refs.orderMap,
      (fatal) => {
        showError(fatal);
    },
      (error) => {
        showError(error);
    });

    tsp.startOver();
    tsp.setTravelMode(google.maps.DirectionsTravelMode.DRIVING);

    tsp.setOnProgressCallback((x, y) => {

      if(y.total > 0){
        let per = Math.round((y.chunkNode / y.total) * 100);
        this.setState({googleOrderProgressPercent: (per >= 100 ? 0 : per)});
      }
      else {
        this.setState({googleOrderProgressPercent: 0});
      }
    });

    console.log('solving');

    for (let i = 0; i < waypoints.length; i++) {
      tsp.addWaypoint({...waypoints[i].location}, () => {
      });
    }

    tsp.solveAtoZ((x) => {
      let order = x.getOrder();

      console.log('solved', order);
      let run = {...this.state.run};
      let pickups = [...run.pickups];

      for(let i = 0; i < order.length; i++){
        pickups[i] = {...pickups[i], pickupOrder: order[i]};
      }
      run.pickups = pickups.sort((a, b) => {
        if (a.pickupOrder < b.pickupOrder) {
          return -1;
        }
        if (a.pickupOrder > b.pickupOrder) {
          return 1;
        }
        return 0;
      });

      this.setState({
        run,
        googleOrderProgressPercent: 0
      });
    });
  }

  onItemChange(item, newValue){
    let pickups = this.state.run.pickups.map(x => {
      let returnValue = x;
      
      // TODO: This is where we would call an API to set the urgent job flag and possibly open a new tab to request the urgent job
      
      if(returnValue.id==item.id){
        returnValue.isUrgentJob = newValue;
      }
      return returnValue;
    });

    this.setState({run: {...this.state.run, pickups}});
  }

  onRemoveItem(item,actionConfirmed){
    if(!actionConfirmed && item && item.confirmationResponse){
      return this.setState({ selectedItem: item, viewModal: true });
    }
    if(this.state.viewModal){
      this.toggle();
    }
    let pickups = [...this.state.run.pickups.filter(x => x.id != item.id)];
    for(let i=0; i<pickups.length;i++){
      pickups[i] = {...pickups[i], pickupOrder: i};
    }
    this.setState({run: {...this.state.run, pickups}});
  }
  orderWithMap(){
    this.setState({orderMode: 'map'});
  }

  componentDidMount(){
    if(this.props.showEdit){
      this.props.loadProjectedRunFields({runId: this.props.run && this.props.run.id}).then(resp => {
        this.setState({ projectedValuesList: mustBeArray(resp && resp.data)});
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.run && prevProps.run && (this.props.run.id !== prevProps.run.id || JSON.stringify(this.props.run) !== JSON.stringify(prevProps.run))){      
      this.setState({ run: this.props.run });
    }
  }
  toggle = () =>{
    this.setState({
      viewModal: !this.state.viewModal
    });
  }
  toggleNotesModal = ({activeRecord={}, type, e}) => {
    this.setState({activeRecord}, () => {
      this.setState({ viewNotesModal: !this.state.viewNotesModal, noteType: type || "pickupNote" });
    });
  };
  handleDeleteNote = ({activeRecord={}, type, e}) => {
    this.setState({activeRecord}, () => {
      this.saveNotes({note: ""});
    });
  };
  saveNotes({note}){
    this.setState(prevState => {
      const {activeRecord, noteType} = prevState;
      let pickupList = mustBeArray(prevState.run && prevState.run.pickups);
      pickupList = pickupList.map(item => {
        return(item.id === (activeRecord && activeRecord.id) ? {...item, [noteType]: note} : item);
      });
      prevState.run.pickups = [...pickupList];
      prevState.viewNotesModal = false;
      prevState.activeRecord = {};
      return prevState;
    });
  }
  
  render() {
    const {viewCompletedRun} = this.props;
    const isCollectionRun = this.state.run && getIsCollectionRun(this.state.run.truckCollectionTypeCode);
    return this.state.run && this.state.run.id ?
      this.state.isOrdering ?
      <div>
        <div ref="map" />
        <div ref="orderMap" />

          <Collapse isOpen={this.state.orderMode == 'list'}>
          { this.state.googleOrderProgressPercent == 0 &&
          <div style={{marginBottom: '10px' }}>
            {!viewCompletedRun && <React.Fragment> <Button color="primary" onClick={this.saveRun}><i className="fa fa-check" /></Button>&nbsp;</React.Fragment>}
            {!viewCompletedRun && <React.Fragment> <Button color="secondary" onClick={this.resetRun}><i className="fa fa-undo" /></Button>&nbsp;</React.Fragment>}
            {/*!viewCompletedRun && <button type="button" className="btn btn-primary" onClick={this.refresh}><i className="fa fa-refresh" />&nbsp;Reload runs</button> */}
            <Button color="secondary" onClick={this.cancel}><i className="fa fa-mail-reply" /></Button>&nbsp;
            {/*<Button color="info" onClick={this.reOrderWithGoogle}>Order with free</Button>*/}
            {/*<Button color="info" onClick={this.reOrderTakeTwo}>Order with Google (up to 25)</Button>*/}
            {!viewCompletedRun && <React.Fragment> <Button color="info" onClick={this.reOrderTakeThree}>Auto</Button>&nbsp;</React.Fragment>}
            {!viewCompletedRun && <Button color="info" onClick={this.orderWithMap}>With Map</Button>}
            
            {!viewCompletedRun &&
              <div style={{marginBottom: '10px', marginTop: '16px', display: "flex", flexWrap: "wrap" }}>
                <span style={{marginRight: "16px"}}>
                  <strong>Allow auto-reorder&nbsp;</strong>
                  <label className="switch switch-3d switch-danger">
                    <input type="checkbox"
                          checked={this.state.run.allowAutoReorder}
                          className="switch-input"
                          onChange={(e) => this.setState({run: {...this.state.run, allowAutoReorder: e.target.checked}})}
                    />
                    <span className="switch-label" />
                    <span className="switch-handle" />
                  </label>
                </span>
                <span>
                  <strong >Edit Run Order&nbsp;</strong>
                  <label className="switch switch-3d switch-danger">
                    <input type="checkbox"
                          checked={this.state.enableEditing}
                          className="switch-input"
                          onChange={(e) => this.setState({enableEditing: e.target.checked})}
                    />
                    <span className="switch-label" />
                    <span className="switch-handle" />
                </label>
                </span>
              </div>
            }
          </div>}
          { this.state.googleOrderProgressPercent > 0 &&
            <Progress
              style={{marginTop: '10px',marginBottom: '10px' }}
              max={100}
                      value={this.state.googleOrderProgressPercent}
                  color="success">
              {this.state.googleOrderProgressPercent}%
            </Progress>
           }
          </Collapse>
        <Collapse isOpen={this.state.orderMode == 'list'}>
          {
            this.state.enableEditing ?
            <UnSortablePickups
              items={this.state.run.pickups}
              onSortEnd={this.onSortEnd}
              onItemChange={this.onItemChange}
              onRemoveItem={this.onRemoveItem}
              pickupStatusList={this.state.pickupStatusList} 
              handleStatusChange={this.handleStatusChange}
              toggleNotesModal={this.toggleNotesModal}
              projectedValuesList={this.state.projectedValuesList}
              handleDeleteNote={this.handleDeleteNote}
              viewCompletedRun={this.props.viewCompletedRun}
              enableEditing={this.state.enableEditing}
              isCollectionRun={isCollectionRun}
            />
          :
          <SortablePickups
            items={this.state.run.pickups}
            onSortEnd={this.onSortEnd}
            onItemChange={this.onItemChange}
            onRemoveItem={this.onRemoveItem}
            pickupStatusList={this.state.pickupStatusList} 
            handleStatusChange={this.handleStatusChange}
            toggleNotesModal={this.toggleNotesModal}
            projectedValuesList={this.state.projectedValuesList}
            handleDeleteNote={this.handleDeleteNote}
            viewCompletedRun={this.props.viewCompletedRun}
            enableEditing={this.state.enableEditing}
            isCollectionRun={isCollectionRun}
          />
          }
          
        </Collapse>
        <Collapse isOpen={this.state.orderMode == 'map'}>
          <SortableMap
            ref="sortMap"
            run={this.state.run}
            onFinishedReorder={this.handleMapOrderFinished}
            isVisible={this.state.orderMode == 'map'}
          />
        </Collapse>
        
        {/* Add/Edit Note component */}
           <AddNotes 
            visible={this.state.viewNotesModal}
            handleCancel={this.toggleNotesModal}
            handleToggle={this.toggleNotesModal}
            handleSaveNote={this.saveNotes}
            note={this.state.activeRecord && this.state.activeRecord.pickupNote}
           />
        {/* Confirmation modal for removing location */}
        <Modal isOpen={this.state.viewModal} toggle={this.toggle}>
            <ModalBody>
                This location has confirmed for a pickup - are you sure you want to remove this location from the run?
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => this.onRemoveItem(this.state.selectedItem, true)}>Yes</Button>
                <Button color="secondary" onClick={this.toggle}>No</Button>
            </ModalFooter>
          </Modal>
      </div> :
          <Button style={this.props.style} color="primary" onClick={this.enterReOrder}>Run Edit</Button>
        : 
        <div />;
  }
}

OrderPickups.propTypes = {
  run: PropTypes.object.isRequired,
  onFinishOrderRun: PropTypes.func.isRequired,
  onEnterReOrderRun: PropTypes.func,
  onLeaveReOrderRun: PropTypes.func
};

export default OrderPickups;